// Top header strip: brand mark + tabs + API key + service status.

import { Activity } from "lucide-react";
import { ServiceStatus } from "./ServiceStatus";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { HealthState, ServiceName } from "../../hooks/useServiceHealth";
import type { TabId } from "./AppShell";

interface Props {
  apiKey: string;
  onApiKeyChange: (v: string) => void;
  health: Record<ServiceName, HealthState>;
  activeTab: TabId;
  onTabChange: (t: TabId) => void;
}

const TABS: { id: TabId; label: string }[] = [
  { id: "builder", label: "Builder" },
  { id: "strategies", label: "Strategies" },
  { id: "monitor", label: "Monitor" },
  { id: "channels", label: "Channels" },
];

export function Header({ apiKey, onApiKeyChange, health, activeTab, onTabChange }: Props) {
  return (
    <header className="flex items-center justify-between gap-4 flex-wrap">
      {/* Left cluster: brand + tabs */}
      <div className="flex items-center gap-6 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <span className="grid place-items-center size-8 rounded-md bg-primary text-primary-foreground">
            <Activity className="size-4" />
          </span>
          <div className="flex flex-col leading-tight">
            <span className="text-sm font-semibold tracking-tight">TraderxAlerts</span>
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
              Signal studio
            </span>
          </div>
        </div>
        <Tabs value={activeTab} onValueChange={(v) => onTabChange(v as TabId)}>
          <TabsList>
            {TABS.map((t) => (
              <TabsTrigger key={t.id} value={t.id}>
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>

      {/* Right cluster: status + API key */}
      <div className="flex items-center gap-4">
        <ServiceStatus state={health} />
        <Input
          placeholder="X-Api-Key"
          value={apiKey}
          onChange={(e) => onApiKeyChange(e.target.value)}
          className="w-[280px] font-mono text-xs"
        />
      </div>
    </header>
  );
}
